import React, { FC, memo } from 'react';
import cn from 'classnames';
import { IconComponentType } from '@creditflowresearch/uilib/Icon';
import IconPlus from '@creditflowresearch/uilib/Icon/IconPlus';
import IconMinus from '@creditflowresearch/uilib/Icon/IconMinus';
import panelGroup from './panelGroup.module.scss';

interface IPanelGroupArrow {
  children?: React.ReactNode,
  isActive?: boolean,
  isOptional?: boolean,
  arrowWrapperClassName?: string,
  optionalWrapperClassname?: string,
  icon?: IconComponentType,
  iconActive?: IconComponentType,
}

const PanelArrow: FC<IPanelGroupArrow> = ({
  children,
  isActive = false,
  isOptional = false,
  arrowWrapperClassName = '',
  optionalWrapperClassname = '',
  icon: Icon = IconPlus,
  iconActive: IconActive = IconMinus,
}) => (
  <>
    { children }
    { isOptional && (
      <span className={ cn(panelGroup.panelGroupHeaderArrowText, optionalWrapperClassname) }>Optional</span>
    ) }
    <span className={ cn(panelGroup.panelGroupHeaderArrowIcon, arrowWrapperClassName) }>
      { isActive ? <IconActive /> : <Icon /> }
    </span>
  </>
);

export default memo(PanelArrow);
